import { Locale } from '@cars4ever/public-ui';

export interface IEnergyClassConfig {
  isIncluded: boolean;
}

const energyClassConfigMap: Record<Locale, IEnergyClassConfig> = {
  [Locale.DK]: {
    isIncluded: true,
  },
  [Locale.SE]: {
    isIncluded: false,
  },
};

export default energyClassConfigMap;
